

$(function(){

'use strict';

/*******************************************
 * 
 * food
 * 
 *******************************************/

(function() {

    // element
    var brand_json;

    // var
    
    // init
    function init() {
        if($('body.page-food').length){
            setup();
        }
    }

    //func
    function setup() {

        brand_json = window.brand_json;

        window.openShopModal = function(brand_post_id, shop_id){
            var shop = brand_json[brand_post_id][shop_id];
            var html = $('<div></div>').addClass('food-Modal').append(
                $('<div></div>')
                .addClass('food-Modal__inner')
                .append(
                    $('<div></div>')
                    .addClass('food-Modal__wrap')
                    .append(
                        $('<div></div>')
                        .addClass('food-Modal__image')
                        .append(
                            $('<img>')
                            .attr('src', shop['shop_photo'])
                        )
                    )
                    .append(
                        $('<div></div>')
                        .addClass('food-Modal__content')
                        .append(
                            $('<div></div>')
                            .addClass('food-Modal__content-heading')
                            .append(
                                $('<div></div>')
                                .addClass('_brand')
                                .html( shop['shop_brand_name'] )
                            )
                            .append(
                                $('<div></div>')
                                .addClass('_name')
                                .html( shop['shop_name']+" 店" )
                            )
                        )
                        .append(
                            $('<div></div>')
                            .addClass('food-Modal__content-body')
                            .append(
                                $('<div></div>')
                                .addClass('food-Modal__content-rows')
                                .append(
                                    $('<div></div>')
                                    .addClass('_row')
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( "住所" )
                                    )
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( shop['shop_address'] )
                                    )
                                )
                                .append(
                                    $('<div></div>')
                                    .addClass('_row')
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( "TEL" )
                                    )
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( shop['shop_tel'] )
                                    )
                                )
                                .append(
                                    $('<div></div>')
                                    .addClass('_row')
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( "FAX" )
                                    )
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( shop['shop_fax'] )
                                    )
                                )
                                .append(
                                    $('<div></div>')
                                    .addClass('_row')
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( "営業時間" )
                                    )
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( shop['shop_timre'] )
                                    )
                                )
                                .append(
                                    $('<div></div>')
                                    .addClass('_row')
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( "定休日" )
                                    )
                                    .append(
                                        $('<div></div>')
                                        .addClass('_col')
                                        .html( shop['shop_holiday'] )
                                    )
                                )
                            )
                        )
                    )
                )
                .append(
                    $('<div></div>')
                    .addClass('food-Modal__map')
                    .append( shop['shop_gmap'] )
                )
                .append(
                    $('<div></div>')
                    .addClass('food-Modal__exButtons')
                )
            );

            if((shop['shop_link_tabelog']!==undefined)&&(shop['shop_link_tabelog'].length!==0)){
                html.find('.food-Modal__exButtons').append(
                    $('<a></a>')
                    .addClass('_button _button--tabelog')
                    .attr('href', shop['shop_link_tabelog'])
                    .html('食べログ')
                );
            }
            if((shop['shop_link_gurunabi']!==undefined)&&(shop['shop_link_gurunabi'].length!==0)){
                html.find('.food-Modal__exButtons').append(
                    $('<a></a>')
                    .addClass('_button _button--gurunabi')
                    .attr('href', shop['shop_link_gurunabi'])
                    .html('ぐるなび')
                );
            }
            if((shop['shop_link_hotpepper']!==undefined)&&(shop['shop_link_hotpepper'].length!==0)){
                html.find('.food-Modal__exButtons').append(
                    $('<a></a>')
                    .addClass('_button _button--hotpepper')
                    .attr('href', shop['shop_link_hotpepper'])
                    .html('ホットペッパー')
                );
            }
            //if(shop['shop_link_tabelog'])

            $.fancybox.open(
                {
                    src : html,
                    type : 'inline',
                    opts : {
                        touch : false
                    }
                }
            );
        }

    }

    init();

})();

/*******************************************
 *******************************************/
});
